export const LAST_ROW_LABEL = 'Total';
